// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .nav {
        width: 100%;
      }
    `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-sidebar-menu/zikata-sidebar-menu.component.ts"],"names":[],"mappings":";MACM;QACE,WAAW;MACb","sourcesContent":["\n      .nav {\n        width: 100%;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
